import {
  IntegrationCredentialsSchema,
  IntegrationV2ResponseSchema,
} from "@redotech/internal-ctx-client";
import * as z from "zod/v4";

export const updateContextualIntegrationCredentials = {
  name: "updateContextualIntegrationCredentials" as const,
  input: z.object({
    integrationId: z.string(),
    credentials: IntegrationCredentialsSchema,
  }),
  output: IntegrationV2ResponseSchema,
};
